module.exports = __webpack_public_path__ + "static/media/ceylon-city-hotel.7b2c9016.png";